import React from "react";
import { Link } from "react-router-dom";
import ProfileLayout from "../../components/profile-redesign/ProfileLayout";
import Panel from "../../components/profile-redesign/Panel";
import Notice from "../../components/profile-redesign/Notice";
import { useProfile } from "../../components/profile-redesign/useProfile";

/*
 * Checkout opens a hosted payment session, so no card details ever reach
 * this app and none are stored against the account. The page explains how
 * paying works rather than offering a card form that could not save
 * anywhere safe.
 */
const STEPS = [
  {
    title: "You pay on a hosted checkout",
    text: "Card details are entered on the payment provider's own page, never on ours.",
  },
  {
    title: "We never see your card",
    text: "Only the order reference and the result of the payment come back to us.",
  },
  {
    title: "Your bank keeps the details",
    text: "Saving a card for reuse is handled by your browser or your bank's wallet.",
  },
];

function ProfilePayments() {
  const { user, isLoading, isError, signOut } = useProfile();

  return (
    <ProfileLayout
      seoTitle="Payment Methods"
      title="Payment Methods"
      subtitle="How payment works on your orders."
      user={user}
      isLoading={isLoading}
      isError={isError}
      onSignOut={signOut}
    >
      <Panel id="c4prf-secure" title="Your Payments Are Secure">
        <ol className="c4prf__steps">
          {STEPS.map((step, index) => (
            <li className="c4prf__step" key={step.title}>
              <span className="c4prf__step-num" aria-hidden="true">
                {index + 1}
              </span>
              <div>
                <p className="c4prf__step-title">{step.title}</p>
                <p className="c4prf__step-text">{step.text}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="c4prf__actions c4prf__actions--start">
          <Link
            className="c4prf__btn c4prf__btn--primary"
            to={process.env.PUBLIC_URL + "/cart"}
          >
            Go To Checkout
          </Link>
          <Link
            className="c4prf__btn c4prf__btn--outline"
            to={process.env.PUBLIC_URL + "/profile/orders"}
          >
            View Order History
          </Link>
        </div>
      </Panel>

      <Notice tone="secure">
        There are no saved cards to show: the account record holds no payment
        methods and orders don't store how they were paid for. Adding a wallet
        would need both a backend model and a tokenised card store — we won't
        keep card numbers in the browser.
      </Notice>
    </ProfileLayout>
  );
}

export default ProfilePayments;
